import React from "react";

const MoveSelect = ({ moves, onSelectMove, selectedMoveId}) => {
  return (
    <div className="col-span-1 w-52">
      <label htmlFor="character" className="block mb-2">
        Preferred Move
      </label>
      <select
        name="moves"
        id="moves"
        className="border border-pink-300/30 bg-pink-400/20 rounded-lg hover:border-pink-300 py-1 w-full px-4 py-2 bg-gray-900 text-white rounded-lg border border-gray-700 focus:outline-none duration-200 ease-in-out"
        onChange={onSelectMove}
        value={selectedMoveId}
      >
        <option value="None">NONE</option>
        {Object.keys(moves).map((char) => (
          <option key={char} value={moves[char]}>
            {char}
          </option>
        ))}
      </select>
    </div>
  );
};

export default MoveSelect;